let lastVideoIdToWatch;
let lastCollectionIdToWatch;

function startFirstSerieVideo() {
	if(lastVideoIdToWatch){
		loadPageVideo(lastVideoIdToWatch);
	}else{
	}
}

var teyutoPreviewPlayer;

let videoCollectionStatusMuted='mute';
function videoTrailerPreviewToggleVolume(muted=false) {
    if(muted==true){
        videoCollectionStatusMuted='mute';
        teyutoPreviewPlayer.muted(true);
        $('.controlTrailerPreviewVideoVolume').html('<i class="ri-volume-mute-fill">');
        return false;
    }
    if(videoCollectionStatusMuted=='mute'){
        videoCollectionStatusMuted='unmute';
        teyutoPreviewPlayer.muted(false);
   		$('.controlTrailerPreviewVideoVolume').html('<i class="ri-volume-up-fill">');

        // se disattivo il muto devo disabilitare il video in riproduzione
        try{
            teyutoVideoPlayer.pause();
            teyutoVideoPlayer.muted(true);
        }catch(err){}
        
    }else{
        videoCollectionStatusMuted='mute';
        teyutoPreviewPlayer.muted(true);
        $('.controlTrailerPreviewVideoVolume').html('<i class="ri-volume-mute-fill">');
    }

}

function videoTrailerPreviewRefresh() {
	teyutoPreviewPlayer.currentTime(false);
}


var step = 1;

function getInfoCollection(idc) {

    if (currentAjaxRequest !== null) {
        currentAjaxRequest.abort();
    }

	var el = '.modal_popup_lc_content';
    
    $(el).html(`
        <div id="loading_results_spinner" class="col-md-12 text-center row" style="margin-top:40vh;"><svg class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>

        <img class="collection-cinema-lighting" style="display:none;" alt="">
        <canvas class="collection-cinema-lighting collection-cinema-lighting-canvas" width="48" height="27" style="opacity:0;"></canvas>
        <canvas class="collection-cinema-lighting collection-cinema-lighting-canvas" width="48" height="27" style="opacity:0;"></canvas>

        <div class="cardSerie row col-md-12">
        <div id="media_serie_header" class="col-sm-12 ">

            <div class="backgroundImageSeries embed-responsive embed-responsive-16by9">

                <div id="previewTrailerCollection" class="previewVideoTrailerCollection">

                </div>

            </div>

        </div>

        <div id="info_serie_header" class="col-sm-12">

            <div class="info_serie_header_container">
                <h1 id="titleSerieCollection" class="mb-1 white"></h1>
                
                <div id="collection_information">
                </div>
                
                <div class="htmlDescription white more" id="htmlDescription"></div>
                <div id="collection_credits"></div>

                <div class="box_video_tags" id="collectionTagBox"></div>

                <div id="htmlBundle"></div>
                <div id="htmlAccess"></div>
             
            </div>

        </div><!-- end div info_serie_header-->

    </div>

    <div class="col-md-12 collection-tab-select" style="display:none;">
        <ul id="selectNavigationCollection" class="channelStyle nav nav-tabs mb-3" style="margin:0 auto;">
            <li class="active selectNavigationCollectionEpisodes" onclick="$('.video_det').hide();$('.video_episodes').show();" data-toggle="tab"><a>${translate('EPISODES')}</a></li>
            <li class="selectNavigationCollectionRelated" onclick="$('.video_det').hide();$('.video_related_contents').show();"  data-toggle="tab"><a>${translate('RELATED_VIDEO')}</a></li>
        </ul>
    </div>

    <div id="video_episodes" class="fixed_w row video_det video_episodes" style="padding:0px;">
        <div id="mainLive" class="mainLive2 pa-1" style="padding-bottom: 50px;">
        </div>
    </div>

    <div id="video_related_contents" class="row video_det video_related_contents" style="padding:0px;display:none;">
        <div id="relatedContents" class="liveHorizontalListVideo col-md-12" style="padding-bottom: 50px;">
        </div>
    </div>


    `);
                
	currentAjaxRequest = $.ajax({
		localCache: true,
		cacheTTL: 0.5,
		type: "GET",
		url: URL_API2 + "/collections/" + idc,
		success: function (json) {
            var obj = JSON.parse(json);
    
            $('#loading_results_spinner').remove();
            $('.collection-tab-select').css('display','flex');
            
            // console.log(json);
  
            currentCollectionTitle = obj.title;
			//avvio il video dall'ultimo dove mi trovo
			lastVideoIdToWatch = obj.next_video_play.id;
			lastCollectionIdToWatch = obj.id;

			if(obj.img_preview_logo_title){
				$('#titleSerieCollection').html('<img class="collectionLogoTitle" src="'+obj.img_preview_logo_title+'">');
			}else{
				$('#titleSerieCollection').html(obj.title);
			}

            //fix img preview background
            if(obj.img_preview_background){
                obj.img_preview = obj.img_preview_background;
            }
                
            if(obj.img_preview){
				$('.previewVideoTrailerCollection').css("background-image", "url('" + obj.img_preview + "')");
				$('.collection-cinema-lighting').attr('src', obj.img_preview).css('display', 'block');
            }
            

			$('#htmlDescription').html(`<div id="readMoreCollection" onclick="readmoreCheckbox($(this));" class='read-more white'><input id='read-more-checkbox' type='checkbox' class='read-more__checkbox' aria-hidden='true'><div class='read-more__text'>${obj.description}</div><label for='read-more-checkbox' class='read-more__label' data-read-more='Read more' data-read-less='See less' aria-hidden='true'></label></div>`);

			if (obj.directors) {
				$('.otherInformation').append(translate('DIRECTORS') + ': ', obj.directors);
			}

			if (obj.actors) {
				$('.otherInformation').append(translate('ACTORS') + ': ', obj.actors);
			}

			// if(objJson[0].subtitles.length==0){
			// 	$('.subtitlesList').hide();
			//   $('.collectionInfoLabel').hide();
			// }else{
			// 	$('.subtitlesList').append(translate("SUBTITLES_AVAILABLE")+': ');
			// 	$('.subtitlesList').show();
			// }

			// for(var i in objJson[0].subtitles)
			// {
			//   $('.subtitlesList').append('<span class="collectionSubtitlesBadge white">'+objJson[0].subtitles[i]+'</span>');
			// }

			$('#collection_information').html("");
			$('#collection_credits').html("");

			let collectioInformation = generateCollectionInfo(obj);
			$('#collection_information').html(collectioInformation);

			// if(objJson[0].country){
			// 	$('#collection_credits').append('<span class="white xbold" style="margin-right:5px;">Country:</span><span class="white gray">'+comma+objJson[0].country+'</span>');
			// }

			if (obj.directors.length > 0) {
				$('#collection_credits').append('<span class="white xbold" style="margin-right:5px;">' + translate('DIRECTORS') + ':</span>');

				for (var i in obj.directors) {
					let comma = "";
					if (i > 0) {
						comma = ", ";
					}
					$('#collection_credits').append('<span class="white gray">' + comma + obj.directors[i] + '</span>');
				}
				$('#collection_credits').append('<br>');
			}

			if (obj.actors.length > 0) {
				$('#collection_credits').append('<span class="white xbold" style="margin-right:5px;">' + translate('ACTORS') + ':</span>');

				for (var i in obj.actors) {
					let comma = "";
					if (i > 0) {
						comma = ", ";
					}
					$('#collection_credits').append('<span class="white gray">' + comma + obj.actors[i] + '</span>');
				}
			}
            
			if (obj.trailer) {
					$(".previewVideoTrailerCollection").append(`<div id="trailer-preview-slot" class="embed-responsive embed-responsive-16by9"></div>`);

                    $.ajax({
                        type: 'GET',
                        url: URL_API2 + '/videos/' + obj.trailer
                    })
                    .done(function (jsonTrailer) {
                        // Successo
                        let objTrailer = JSON.parse(jsonTrailer);
                        if (Array.isArray(obj)) {
                            objTrailer = objTrailer[0];
                        }

                        var source = objTrailer.source;
                        if(source){
                            try {
                                teyutoPreviewPlayer.dispose();
                            } catch (error) {
                            }

                            // core condiviso TyPlayer, preset preview:
                            // autoplay muto in loop, nessun controllo
                            teyutoPreviewPlayer = TyPlayer.create({
                                container: '#trailer-preview-slot',
                                id: 'teyutoPreviewPlayer',
                                poster: obj.img_preview,
                                src: source,
                                type: 'application/x-mpegURL',
                                opts: { preview: true }
                            });

                            // analytics trailer: ripristinate (adapter TyPlayer)
                            initPlayerStat(teyutoPreviewPlayer, obj.trailer);

                            $('.previewVideoTrailerCollection').css("background-image", "");

                            //glow ambientale dinamico come sulla pagina video
                            //(helper condiviso definito in live.js)
                            startAmbientCanvasGlow(
                                'collectionAmbientTimer',
                                '.collection-cinema-lighting-canvas',
                                '#teyutoPreviewPlayer',
                                'img.collection-cinema-lighting'
                            );

                        }
                    })
	
					$('#media_serie_header').append('<div id="trailer_btns_box"><a class="controlTrailerPreviewVideoRefresh button-void" onclick="videoTrailerPreviewRefresh();"><i style="color:white !important;"  class="ri-arrow-go-forward-line"></i></a><a class="controlTrailerPreviewVideoVolume button-void" onclick="videoTrailerPreviewToggleVolume();"><i  style="color:white !important;" class="ri-volume-mute-fill"></i></a></div>');

	
			}

            
            //watch without adv
            var htmlAccess='';
			let watch_no_adv="";
			if (obj.access == 'ok' && obj.show_ads_on_free == true) {
				watch_no_adv='<a onclick="openModalPaymentPreview('+idc+');"  class="button-secondary mr-1 mb-1"> ' + translate("WATCH_WITHOUT_ADVERTISING") +'</a>';
			}


            var htmlProgress='';
            // alert(obj.next_video_play.last_seen);
            if(userData.status == 'success' && obj.next_video_play.last_seen && obj.next_video_play.last_seen > 5 ){
            //creo la barretta del progresso; 
                var progress = (obj.next_video_play.last_seen / obj.next_video_play.duration_seconds) * 100;

                htmlProgress = ` <div class="progress-bar-wrapper" id="progressBarWrapper-collection">
                    <div class="progress-bar">
                        <div class="progress-bar__fill" style="width: ${progress}%"></div>
                    </div>
                </div>`;
            }

            //mostro lucchetto?
            let htmlIconPlay = '<i class="ri-play-fill"></i>';
            let htmlCallToActionPlay = 'startFirstSerieVideo();'

            let htmlCallToActionDownload = '';
            if(obj.video_ids.length > 0 ){
                htmlCallToActionDownload =`startDownloadContentBatch('${obj.video_ids.join(",")}');`;
            }

            if (obj.access == 'not_paid') {
			    htmlIconPlay = '<i class="ri-lock-fill"></i>';	
                htmlCallToActionPlay = 'openModalPaymentPreview('+idc+')';
                htmlCallToActionDownload = htmlCallToActionPlay;
			}
            if (obj.access == 'preview') {
			    htmlIconPlay = '<i class="ri-lock-fill"></i>';	
                htmlCallToActionPlay = 'openModalLogin()';
                htmlCallToActionDownload = htmlCallToActionPlay;
			}

            htmlAccess = `<a onclick="${htmlCallToActionPlay}" class="button-primary button-full  btn-start-now-collection mr-1 mb-1"> ${htmlIconPlay} ${ translate("WATCH_NOW")}</a> ${htmlProgress} ${watch_no_adv}`;

            if((obj.access == 'ok' || obj.access == 'preview') && obj.video_ids.length == 0){
				htmlAccess = '';
			}

            //controllo se tutti i video sono stati scaricati, se si metto il check sul download geneale
            const allDownloaded = obj.video_ids.every(videoId => listDownloadedVideosIds.includes(videoId));
            let downloadedText = `<i class="ri-download-line"></i> ${translate("DOWNLOAD")} ${obj.video_ids.length === 1 ? '' : obj.video_ids.length + ' ' + translate('EPISODES')} `;
            if(allDownloaded){
                downloadedText = `<i class="ri-check-line font-size-16"></i>`;
            }

           htmlAccess += `
                ${obj.video_ids.length > 0 ? `
                    <a onclick="${htmlCallToActionDownload}" class="button-secondary button-full btn-start-now-collection mr-1 mb-1 downloadedVideoMultiple downloadedVideo-${obj.video_ids[0]}">${downloadedText}</a>
                ` : ''}
            `;

	        let shareBtnHtml = '<button class="button-round controlButtonShare" onclick="shareThisElement(\'collection\', '+obj.id+');"><i class="ri-share-fill font-size-16"></i> Share</button>';
			
			var reminder_obj = '';
			reminder_obj = '<button onclick="event.stopPropagation();openModalSetSavedContent(' + obj.id + ',\'serie\');" class="mr-1  button-round controlSetLikeSerie reminder_serie' + obj.id + '"></button>';
				
            $('#htmlAccess').append(`<div class="mb-1">${htmlAccess}</div><div>${reminder_obj} ${shareBtnHtml}</div>`);	


            createTagsSection('#collectionTagBox', obj.tags);
            checkIfContentIsSaved(idc, 'serie');

		}

	});
	

    var urlapi = `${URL_API}/video/?f=get_video&step=1&collection=${idc}`;
    getLiveInLive2(urlapi, "#mainLive");

    getContentsHorizontal(`${URL_API2}/contents/collections?f=get_collection&id=${idc}&option=related_collections`, 1, "#video_related_contents");

    // pagina reale: lo scroll è quello della finestra
    $('html, body').scrollTop(0);

	setFirebaseAnalyticsPage("collection");
    var fireObj = {
        "collection": {
            id: idc
        }
    };
    setFirebaseAnalyticsEvent(fireObj);

}

function generateCollectionInfo(obj) {
	let html="";

	if (obj.duration) {
		let durationHtml="";
		if(Number.isInteger(obj.duration)){
			durationHtml = obj.duration+" "+translate('EPISODES');
		}else{
			durationHtml = obj.duration;
		}
		html += '<span class="infoCollectionTextMargin white">'+durationHtml+'</span>';
	}


	if (obj.year) {
		html += '<span class="span_extra_info infoCollectionTextMargin white">' + obj.year + '</span>';
	}

	if (obj.original_language) {
		let originalLanguageString = obj.original_language;
		if (obj.full_original_language) {
			originalLanguageString = obj.full_original_language;
		}

		html+=`<span tooltip="${translate('PRODUCTION_COUNTRY')}" flow="right" class="label_extra_info infoCollectionTextMargin originalLanguageText">${originalLanguageString}</span>`;
	}

	if (obj.age_restrictions) {
		html+='<span tooltip="' + translate('PARENTAL_GUIDANCE_' + obj.age_restrictions) + '" flow="right" class="label_extra_info infoCollectionTextMargin ageRestrictionText">' + obj.age_restrictions + '</span>';
	}


	return html;
}